// export default {
//     apiUrl: 'http://localhost/inet/api/api',
//     SITEKEY: "6LcC4dMUAAAAALbc6Md4p72rcDAcJ4nHNpNNRrX8", //sagar add site key for captcha varification
//     dateFormat: 'DD-MMM-YYYY',
//     dateFormatWithTime: 'DD-MMM-YYYY hh:mm A',
//     dateFormatWithSlash: 'DD/MM/YYYY',
// 	dateFormatInNumbersOnly: 'YYYY-MM-DD',
//     EDITOR_API_KEY: 'wpura89gl26tra1bl7m7pr58f9th8iztb007mxkpsp7sbgmn',
//     imageUrl: 'http://localhost/inet/api/', //sagar add imageUrl path so that we can use image url to view image
// };


export default {
    apiUrl: 'https://inetapi.netedgecomputing.com/api/api',
    
    SITEKEY: "6LcC4dMUAAAAALbc6Md4p72rcDAcJ4nHNpNNRrX8", //sagar add site key for captcha varification
    dateFormat: 'DD-MMM-YYYY',
    dateFormatWithTime: 'DD-MMM-YYYY hh:mm A',
    dateFormatWithSlash: 'DD/MM/YYYY',
	dateFormatInNumbersOnly: 'YYYY-MM-DD',
    EDITOR_API_KEY: 'wpura89gl26tra1bl7m7pr58f9th8iztb007mxkpsp7sbgmn',
    imageUrl: 'https://inetapi.netedgecomputing.com/api/public/img/NE.png', //sagar add imageUrl path so that we can use image url to view image
};
